import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {data} from "autoprefixer";

@Component({
    selector: 'app-draft-confirmation-dialog',
    templateUrl: './draft-confirmation-dialog.component.html',
    styleUrls: ['./draft-confirmation-dialog.component.css'],
    standalone: false
})
export class DraftConfirmationDialogComponent implements OnInit{
  dialogType: string = '';
  dialogTitle: string = '';
  dialogSubTitle: string = '';

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<DraftConfirmationDialogComponent>) {
  }

  ngOnInit(): void {
    this.dialogType = this.data.dialogType;
    this.dialogTitle = this.data.dialogTitle;
    this.dialogSubTitle = this.data.dialogSubTitle;
  }

  closeDialog(confirmDialog: boolean) {
    this.dialogRef.close(confirmDialog)
  }
}
